import React, { Component } from 'react'
import { get } from '../../utils/networking'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
import User from '../user'
import { connect } from 'react-redux'
import { getHeader } from './action'
import history from '../../redux/routerHistory'
import Search from '../search'
import CheckInPopup from '../checkInPopup'

export class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            findServices: [],
            lastestBlog: null,
            wellnessLifeStyle: [],
            wellnessTravel: [],
            isShowCheckInPopup: false,
            profile: {},
            currentStore: null
        }
    }
    componentDidMount() {
        this.props.getHeader();
    }

    handleGetProfile(callback) {
        get('user/getMyProfile', "customer", result => {
            this.setState({
                profile: result,
                currentStore: result.stores[0]
            })
        }, () => callback())
    }
    partnerLogOut() {
        window.localStorage.removeItem("partner_access_token");
        this.setState();
    }
    customerLogOut() {
        window.localStorage.removeItem("access_token");
        this.setState();
    }

    render() {


        const {
            findServices,
            wellnessLifeStyle,
            lastestBlog,
            wellnessTravel
        } = this.props

        let {
            isShowCheckInPopup,
            profile,
            currentStore
        } = this.state

        const that = this;

        return (
            <header>
                <CheckInPopup
                    profile={profile}
                    currentStore={currentStore}
                    isShow={isShowCheckInPopup}
                    cancel={() => this.setState({ isShowCheckInPopup: false })}
                    changeCurrentStore={(store) => this.setState({ currentStore: store })} />
                <div className="border_line_bottom">
                    <div className="container">
                        <div className="content clearfix">
                            <div className="logo" id="logo">
                                <NavLink to="/" className="reset_f5"><img src="/assets/images/spafinder-wellness-365.png" alt="" /></NavLink>
                            </div>
                            <div className="icon_menu_sp clearfix">
                                <div className="menu_icon">
                                    <i className="fa fa-bars" aria-hidden="true"></i>
                                </div>
                                <div className="search_icon">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div className="account_spa_menu">
                                <nav className="account clearfix">
                                    <ul className="clearfix">
                                        <li className="sp_none"><NavLink to="/pages/about-us" className="reset_f5">About Us</NavLink></li>
                                        <li className="sub_menu sp_none"><NavLink to="#" className="reset_f5">Customer</NavLink>
                                            {
                                                (window.localStorage.getItem("access_token")) ?
                                                    <ul className="business">
                                                        <li><NavLink to="/user" className="reset_f5">My Account</NavLink></li>
                                                        <li><NavLink to="#" className="reset_f5" onClick={() => this.handleGetProfile(this.setState({ isShowCheckInPopup: true }))}>Check in now</NavLink></li>
                                                        <li><NavLink to="#" onClick={this.customerLogOut.bind(this)}>Sign out</NavLink> </li>
                                                    </ul> :
                                                    <ul className="business">
                                                        <li><NavLink to="/login" className="reset_f5">Sign in</NavLink></li>
                                                        <li><NavLink to="/register" className="reset_f5">Sign up</NavLink></li>
                                                    </ul>
                                            }
                                        </li>
                                        <li className="sub_menu sp_none"><NavLink to={(window.localStorage.getItem("partner_access_token")) ? "/partner" : "/partner/login"} className="reset_f5">Business Partners</NavLink>
                                            <ul className="business">
                                                <li>{(window.localStorage.getItem("partner_access_token")) ? <NavLink to="#" onClick={this.partnerLogOut.bind(this)}>Log out</NavLink> : < NavLink to="/partner/login" className="reset_f5">Partner Login</NavLink>}</li>
                                                <li><NavLink to="/register-partner" className="reset_f5">Join the Network</NavLink></li>
                                            </ul>
                                        </li>
                                        <li className="sp_none"><NavLink to="/pages/help" className="reset_f5">Help</NavLink></li>
                                        <li className="sub_menu sp_none"><NavLink to="#" className="flag_txt reset_f5"><span className="flag usa-flag"></span> US</NavLink>
                                            <ul className="flag_ul">
                                                <li><NavLink to="#" className="flag_txt"><span className="flag uk-flag"></span> UK</NavLink></li>
                                            </ul>
                                        </li>
                                        <li className="search_m"><NavLink to="#" className="flag_txt"><span className="search img_search"></span> S</NavLink>
                                            <ul className="search search_1">
                                                <li className="quick-search">
                                                    <Search history={this.props.history} />
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                                <nav className="spa_menu clearfix">
                                    <ul className="main clearfix">
                                        <li className="h_sub_menu"><NavLink to="#"> FIND SERVICES</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu" style={{ background: "url(" + require('../../assets/images/background-menu.png') + ")" }}>
                                                <li>
                                                    <div className="ct_find">
                                                        <div className="ct_search_h">
                                                            <Search history={this.props.history} />
                                                        </div>
                                                        <div className="menu_item">
                                                            <ul className="clearfix">
                                                                {findServices.map((article, i) =>
                                                                    <li key={i}>
                                                                        <NavLink to="#" className="ct_find_1">{article.name}</NavLink>
                                                                        <ul className="click_01">
                                                                            {article.categories.map((category, j) =>
                                                                                <li key={j}>
                                                                                    <NavLink to={"/blog/category/" + category.slug} className="reset_f5">{category.name}</NavLink>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        {
                                            wellnessTravel.length > 0
                                            &&
                                            wellnessTravel[0].categories.length > 0
                                            &&
                                            <li><NavLink to={"/blog/category/" + wellnessTravel[0].categories[0].slug} className="reset_f5">WELLNESS TRAVEL</NavLink></li>
                                            ||
                                            <li><NavLink to="#" className="reset_f5">WELLNESS TRAVEL</NavLink></li>
                                        }
                                        <li className="h_sub_menu"><NavLink to="/blogs" className="reset_f5">WELLNESS LIFESTYLE</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu">
                                                <li>
                                                    <div className="ct_wellness">
                                                        <div className="menu_item">
                                                            <ul className="clearfix">
                                                                {lastestBlog &&
                                                                    <li className="item1">
                                                                        <div className="clearfix">
                                                                            <div className="img">
                                                                                <NavLink to={"/spa/" + lastestBlog.slug}>
                                                                                    <img src={lastestBlog.photo} alt="" />
                                                                                </NavLink>
                                                                            </div>
                                                                            <div className="comment">
                                                                                <p>{lastestBlog.title}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                }
                                                                {wellnessLifeStyle.map((article, i) =>
                                                                    <li key={i} className="item2">
                                                                        <NavLink to="#">{article.name}</NavLink>
                                                                        <ul>
                                                                            {article.categories.map((category, j) =>
                                                                                <li key={j}>
                                                                                    <NavLink to={"/blog/category/" + category.slug}>{category.name}</NavLink>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li><NavLink to="/offers" className="reset_f5">SPECIALS</NavLink></li>
                                        {/* <li className="h_sub_menu"><NavLink to="#"> GIFT CARDS</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu">
                                                <li>
                                                    <div className="ct_gift">
                                                        <div className="menu_item">
                                                            <ul className="clearfix">
                                                                <li className="item1">
                                                                    <div className="clearfix">
                                                                        <div className="img">
                                                                            <img src="images/img01.jpg" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li className="item2">
                                                                    <div>
                                                                        <NavLink to="#"> THREE WAYS TO BUY</NavLink>
                                                                        <ul>
                                                                            <li><NavLink to="#"> Print a Gift Card</NavLink></li>
                                                                            <li><NavLink to="#"> Email a Gift Card</NavLink></li>
                                                                            <li><NavLink to="#"> Mail a Gift Card</NavLink></li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                                <li className="item3">
                                                                    <div>
                                                                        <ul className="clearfix">
                                                                            <li>
                                                                                <NavLink to="#"> See How To Redeem</NavLink>
                                                                            </li>
                                                                            <li>
                                                                                <NavLink to="#"> Corporate Gift Card Sales</NavLink>
                                                                            </li>
                                                                            <li>
                                                                                <NavLink to="#"> Gift Ideas</NavLink>
                                                                            </li>
                                                                            <li>
                                                                                <NavLink to="#"> Gift Card Exchange Program</NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li> */}

                                        <li className="pc_none"><NavLink to="/pages/about-us" className="reset_f5">About Us</NavLink></li>
                                        <li className="h_sub_menu pc_none"><NavLink to="/user" className="reset_f5">Customer</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu">
                                                <li>
                                                    <div className="ct_business">
                                                        <div className="menu_item">
                                                            <ul>
                                                                <li>
                                                                    {
                                                                        (window.localStorage.getItem("access_token")) ?
                                                                            <ul className="business">
                                                                                <li><NavLink to="/user" className="reset_f5">My Account</NavLink></li>
                                                                                {/* <li><NavLink to="#" className="reset_f5" onClick={() => this.setState({ isShowCheckInPopup: true })}>Check in now</NavLink></li> */}
                                                                                <li><NavLink to="#" onClick={this.customerLogOut.bind(this)}>Sign out</NavLink> </li>
                                                                            </ul> :
                                                                            <ul className="business">
                                                                                <li><NavLink to="/login" className="reset_f5">Sign in</NavLink></li>
                                                                                <li><NavLink to="/register" className="reset_f5">Sign up</NavLink></li>
                                                                            </ul>
                                                                    }
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="h_sub_menu pc_none"><NavLink to={(window.localStorage.getItem("partner_access_token")) ? "/partner" : "/partner/login"} className="reset_f5">Business Partners</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu">
                                                <li>
                                                    <div className="ct_business">
                                                        <div className="menu_item">
                                                            <ul>
                                                                <li>
                                                                    {
                                                                        (window.localStorage.getItem("partner_access_token")) ?
                                                                            <ul className="business">
                                                                                <li><NavLink to="#" onClick={this.partnerLogOut.bind(this)}>Sign out</NavLink> </li>
                                                                                <li><NavLink to="/register-partner" className="reset_f5">Join the network</NavLink></li>
                                                                            </ul> :
                                                                            <ul className="business">
                                                                                <li><NavLink to="/partner/login" className="reset_f5">Sign in</NavLink></li>
                                                                                <li><NavLink to="/register-partner" className="reset_f5">Join the network</NavLink></li>
                                                                            </ul>
                                                                    }
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="pc_none"><NavLink to="/pages/help" className="reset_f5">Help</NavLink></li>
                                        <li className="h_sub_menu pc_none"><NavLink to="#" className="flag_txt"><span className="flag usa-flag"></span> US</NavLink>
                                            <span className="a_sub_menu"></span>
                                            <ul className="sub-menu">
                                                <li>
                                                    <div className="ct_flag">
                                                        <div className="menu_item">
                                                            <ul>
                                                                <li>
                                                                    <ul>
                                                                        <li>
                                                                            <NavLink to="#" className="flag_txt"><span className="flag uk-flag"></span> UK</NavLink>
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header >
        )
    }
}

export default connect(
    state => ({
        ...state.header
    }),
    dispatch => ({
        getHeader: () => dispatch(getHeader())
    })
)(Header)


// WEBPACK FOOTER //
// ./src/components/header/index.js